import React from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import DataDisplay, {
  useResponsiveDataDisplayVariant,
} from '@sharedCR/coreDesignSystem/DataDisplay';

import useLoanId from 'hooks/useLoanId';
import useTruncatedGeneral from 'hooks/useTruncatedGeneral';

import {
  selectEntityChangedPropsById,
  selectPropertyAndLoanEditDataHeaderInfo,
} from 'store/loanApplications/selectors';

import {
  propertySummaryCardStyles,
  propertySummaryCardsWrapperStyles,
} from './AdditionalComponents.styles';
import { getPropertySummaryInfoConfig } from './Title.utils';

const PropertyAdditionalInfo = () => {
  const [onMouseOver, onResetTooltipState, TruncatedProvider] = useTruncatedGeneral();

  const loanId = useLoanId();

  const headerInfo = useSelector(selectPropertyAndLoanEditDataHeaderInfo);
  const loanPendingChanges = useSelector(selectEntityChangedPropsById(loanId));

  const dataDisplayVariant = useResponsiveDataDisplayVariant();

  const summaryInfo = getPropertySummaryInfoConfig({
    loanPendingChanges,
    headerInfo,
  });

  return (
    <Box
      sx={propertySummaryCardsWrapperStyles}
      onMouseLeave={onResetTooltipState}
      onMouseOver={onMouseOver}
    >
      <TruncatedProvider />

      {summaryInfo.map(({ name, value, icon, iconColor, changeKind }) => (
        <Box key={name} sx={propertySummaryCardStyles}>
          <DataDisplay
            changeKind={changeKind}
            icon={icon}
            iconColor={iconColor}
            title={name}
            value={value}
            variant={dataDisplayVariant}
          />
        </Box>
      ))}
    </Box>
  );
};

export default PropertyAdditionalInfo;
